import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/home/index.vue'
import edit from '../views/home/edit.vue'
import login from '../views/login/login.vue'
import view from '../views/home/view.vue'
import editnew from '../views/home/temp1.vue'
import share from '../views/home/share.vue'
import template2 from '../views/template/index.vue'
import template3 from '../views/template/template3.vue'
import template4 from '../views/template/template4.vue'
import term from '../views/login/term.vue'
import privacy from '../views/login/privacy.vue'
import human from '../views/human/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: index
  },
  {
    path: '/index',
    name: 'home',
    component: index
  },
  {
    path: '/edit',
    name: 'edit',
    component: edit
  },
  {
    path: '/view',
    name: 'view',
    component: view
  },
  // {
  //   path: '/template',
  //   name: 'template',
  //   component: template
  // },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/template2',
    name: 'template2',
    component: template2
  },
  {
    path: '/template3',
    name: 'template3',
    component: template3
  },
  {
    path: '/template4',
    name: 'template4',
    component: template4
  },{
    path: '/editnew',
    name: 'editnew',
    component: editnew
  },{
    path: '/share',
    name: 'share',
    component: share
  },{
    path: '/term',
    name: 'term',
    component: term
  },{
    path: '/privacy',
    name: 'privacy',
    component: privacy
  },{
    path: '/human',
    name: 'human',
    component: human
  }
]

const router = new VueRouter({
  routes
})

export default router
